import { Color } from "@tiptap/extension-color";
import Highlight from "@tiptap/extension-highlight";
import Link from "@tiptap/extension-link";
import Placeholder from "@tiptap/extension-placeholder";
import TextAlign from "@tiptap/extension-text-align";
import TextStyle from "@tiptap/extension-text-style";
import Typography from "@tiptap/extension-typography";
import Underline from "@tiptap/extension-underline";
import { useEditor as useTipTapEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import SizableImage from "components/ui/atoms/Editor/extensions/SizableImage";

const useEditor = ({ html, onChange, onBlur }) => {
  const editor = useTipTapEditor({
    extensions: [
      StarterKit,
      TextStyle,
      Color,
      Link,
      Typography,
      Underline,
      Placeholder.configure({
        placeholder:
          "Write a note here, begin with a title by pressing # then space",
      }),
      Highlight.configure({ multicolor: true }),
      SizableImage.configure({
        inline: true,
        allowBase64: true,
        HTMLAttributes: {
          style: "display:block;margin:0 auto;",
        },
      }),
      TextAlign.configure({
        types: ["heading", "paragraph"],
      }),
    ],
    content: html,
    onUpdate({ editor }) {
      onChange(editor.getHTML());
    },
    onBlur({ editor }) {
      onBlur(editor.getHTML());
    },
  });

  return { editor };
};

export default useEditor;
